export { default } from './menu-type-modal';
